document.addEventListener("DOMContentLoaded", initFixedPoints);
document.addEventListener("shopify:section:load", initFixedPoints);

function initFixedPoints() {
  const points = document.querySelectorAll(".fixed-point");
  const mapWrappers = document.querySelectorAll(
    ".fixed-points-location .map-wrapper"
  );

  if (!points.length || !mapWrappers.length) return;

  // Reset all points and maps
  points.forEach((p) => p.classList.remove("active"));
  mapWrappers.forEach((m) => {
    m.classList.remove("active");
  });

  // Find the first map wrapper with a valid iframe
  let defaultIndex = Array.from(mapWrappers).findIndex((wrapper, i) => {
    const iframe = wrapper.querySelector("iframe");
    return iframe && iframe.src && iframe.src.trim() !== "" && points[i];
  });

  // Fallback to first element if none found
  if (defaultIndex === -1) defaultIndex = 0;

  // Activate default point and map
  if (points[defaultIndex] && mapWrappers[defaultIndex]) {
    points[defaultIndex].classList.add("active");
    mapWrappers[defaultIndex].classList.add("active");
  }

  // Click handler
  points.forEach((point, index) => {
    point.addEventListener("click", () => {
      const isActive = point.classList.contains("active");

      // Reset all points and maps
      points.forEach((p) => p.classList.remove("active"));
      mapWrappers.forEach((m) => {
        m.classList.remove("active");
        m.classList.remove("map-wrapper-active");
      });

      // Activate clicked point & corresponding map
      if (!isActive && points[index] && mapWrappers[index]) {
        points[index].classList.add("active");
        mapWrappers[index].classList.add("active");
      }
    });
  });
}
